<template>
  <div>
    <c-box
      title="Достижение целей"
      header-divider
      :loading="loading"
      without-left-padding
    >
      <template v-slot:header-right>
        <form class="form-inline">
          <span class="text-gray divider">|</span>
          <c-select
            v-if="Object.keys(monthsDatesFormated).length"
            v-model="monthDate"
            title="ДАННЫЕ ЗА ПЕРИОД:"
            form-group
            :options="monthsDatesFormated"
          />
          <div class="form-group">
            График
            <label>
              <input
                v-model="view"
                type="radio"
                class="minimal"
                value="chart"
              >
            </label>
            Таблица
            <label>
              <input
                v-model="view"
                type="radio"
                class="minimal"
                value="table"
              >
            </label>
          </div>
        </form>
      </template>

      <table
        v-if="view === 'table' && !loading && dataTableVisible.length"
        class="table"
      >
        <thead>
          <tr>
            <th>Цель</th>
            <th>Достижение цели</th>
            <th>Целевые визиты</th>
            <th>Конверсия</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item of dataTableVisible"
            :key="item.Цель"
          >
            <td v-text="item.Цель" />
            <th
              class="text-success"
              v-text="item.Достижения"
            />
            <th
              class="text-success"
              v-text="item.Визиты"
            />
            <th v-text="item.Конверсия + '%'" />
          </tr>
        </tbody>
      </table>
      <no-data v-if="view === 'table' && !loading && !dataTableVisible.length" />

      <div id="mtg-g">
        <c-line-chart
          v-if="view === 'chart' && !loading && dataChartVisible.length"
          :chart-data="chartData"
          :options="chartOptions"
          :height="200"
        />
      </div>
      <no-data v-if="view === 'chart' && !loading && !dataChartVisible.length" />
    </c-box>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import CBox from '../../../../../../../resources/js/components/ui/CBox.vue'
import NoData from '../../../../../../../resources/js/components/NoData.vue'
import sengine from '../../../../../../../resources/js/mixins/sengine'
import diagramColors from '../../../../../../../resources/js/mixins/diagramColors'
import CLineChart from '../../../../../../../resources/js/components/ui/CLineChart.vue'
import CSelect from '../../../../../../../resources/js/components/ui/CSelect'
import { getMonthsFormated } from '../../../../../../../resources/js/helper'
import apiService from '../../apiService'
import Notification from '../../../../../../../resources/js/notification'

const MONTH_DATE_FORMAT = 'YYYY-MM-DD'

export default {
  name: 'MetricTrafficGoals',
  components: { CLineChart, NoData, CBox, CSelect },
  mixins: [sengine, diagramColors],
  data () {
    return {
      view: 'table',
      monthDate: moment().subtract(1, 'months').startOf('month').format(MONTH_DATE_FORMAT),
      monthlyReport: [],
      dataTable: [],
      dataChart: [],
      loading: true,
      chartOptions: {
        scales: {
          xAxes: [{
            gridLines: {
              display: false,
              drawBorder: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: 'Визиты'
            }
          }]
        },
        elements: {
          point: {
            radius: 3
          }
        },
        legend: {
          position: 'bottom',
          labels: {
            boxWidth: 7,
            fontStyle: 'bold',
            fontColor: '#282828',
            usePointStyle: true
          }
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      }
    }
  },
  computed: {
    /**
     * Элементы выпадающего списка с выбором периода (месяца).
     */
    monthsDatesFormated () {
      let dates = {}

      if (this.clientProjects.length) {
        dates = getMonthsFormated(this.clientProjects[0].work_start_date, moment().subtract(1, 'month'))
      }

      return dates
    },
    dataTableVisible () {
      return this.dataTable.filter(i => i.НапечататьВОтчете)
    },
    dataChartVisible () {
      return this.dataChart.filter(i => i.НапечататьВОтчете)
    },
    chartData () {
      const dates = []

      for (const month in this.dataChartVisible[0]) {
        if (['Цель', 'Динамика', 'НапечататьВОтчете'].includes(month)) {
          continue
        }

        dates.push(month)
      }

      return {
        labels: dates,
        datasets: this.dataChartVisible.map((item, index) => {
          const visits = []

          for (const d in item) {
            if (Number.isInteger(item[d])) {
              visits.push(item[d])
            }
          }

          return {
            label: item.Цель,
            data: visits,
            fill: false,
            borderColor: this.getNextDiagramColor(index),
            lineTension: 0
          }
        })
      }
    },
    ...mapState({
      domainSelected: state => state.seo.client.domains.selected,
      clientProjects: state => state.seo.client.projects.projects
    })
  },
  watch: {
    monthDate () {
      this.fetchMonthlyReport()
    }
  },
  mounted () {
    if (this.domainSelected) {
      this.fetchMonthlyReport()
    }
    this.$root.$on('clientDomainsSelectedChange', this.fetchMonthlyReport)
  },
  destroyed () {
    this.$root.$off('clientDomainsSelectedChange', this.fetchMonthlyReport)
  },
  methods: {
    fetchMonthlyReport () {
      this.dataTable = []
      this.dataChart = []
      this.loading = true
      const month = 1 + moment(this.monthDate, MONTH_DATE_FORMAT).month()
      const year = moment(this.monthDate, MONTH_DATE_FORMAT).year()

      apiService.getReport(this.domainSelected, year, month)
        .then(response => {
          this.monthlyReport = response.data[0]
          const reportData = this.monthlyReport ? this.monthlyReport.ДанныеОтчета : {}
          this.dataTable = reportData.ТаблицаДостиженийЗаМесяц || []
          this.dataChart = reportData.ТаблицаДостиженийЗаГод || []
        })
        .catch(() => {
          Notification.notifyError({
            title: 'Ошибка',
            content: 'Достижение целей. Не удалось загрузить ежемесячный отчет.'
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "./resources/css/_variables.scss";

  #mtg-g {
    min-width: 753px;
  }

  .divider {
    @media (max-width: $smBreakpoint) {
      display: none;
    }

    margin-right: 10px;
  }
</style>
